import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="not-found-page min-h-screen flex items-center justify-center bg-gray-50">
      <div className="container mx-auto px-4 text-center">
        <h1 className="text-8xl md:text-9xl font-bold text-[#4285f4] mb-6">
          404
        </h1>
        <h2 className="text-3xl md:text-4xl font-semibold text-[#3d3d3d] mb-8">
          页面未找到
        </h2>
        <p className="text-gray-600 mb-12 max-w-2xl mx-auto">
          很抱歉，您访问的页面不存在或已被移除。请检查您的网址是否正确，或返回首页继续浏览。
        </p>
        <Link
          to="/"
          className="px-8 py-3 bg-[#4285f4] text-white rounded-md hover:bg-[#3367d6] transition-colors inline-block"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
